import React, { useEffect } from "react";
import PhoneHeader from "../../Components/Common/PhoneHeader";
import { useHistory } from "react-router-dom";

const ContactUs = () => {
  const history = useHistory();
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  useEffect(() => {
    if (standalone) {
      history.push("/addtohome");
    }
  }, []);
  useEffect(() => {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    (window.orientation == 90 || window.orientation == -90) &&
      isMobile &&
      history.push("/rotate");
    window.addEventListener(
      "orientationchange",
      function () {
        var isForbidden =
          (window.orientation == 90 || window.orientation == -90) && isMobile;
        if (isForbidden) {
          history.push("/rotate");
        }
      },
      false
    );
  }, []);
  return (
    <div className="Container">
      <div className="mobileContainer">
        <div className="ContactUsPage">
          <img
            src={require("../../assets/images/SplashLogo.png")}
            id="AboutImage"
          />
          <p id="BillHistory">
            آدرس شرکت: تهران ، خیابان سمیه ، بن بست پروین ، پلاک 2 ، طبقه اول
          </p>
          <p
            id="BillHistory"
            class="pointer"
            onClick={() => window.open("tel:02188846186")}
          >
            تلفن: 02188846186
          </p>
          <p id="BillHistory">ایمیل: info@mycontor.ir</p>
        </div>
        <PhoneHeader text={"تماس با ما"} />
      </div>
    </div>
  );
};

export default ContactUs;
